"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themeLookup = themeLookup;
exports.edgeSizes = exports.animate = exports.settings = exports.zindex = exports.fonts = exports.leading = exports.colors = void 0;

var _core = require("@emotion/core");

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var colors = {
  white: '#fff',
  black: '#333',
  blue: {
    primaryDark: '#0094ab',
    primary: '#00a6c2',
    primaryLight: '#17b7da',
    secondaryDark: '#57cadc',
    secondary: '#cff5fd',
    secondaryLight: '#ebfcff'
  },
  cs: {
    primaryDark: '#33a995',
    primary: '#3fB9A4',
    primaryLight: '#1AC7A9',
    secondaryDark: '#79CEBF',
    secondary: '#C5EAE3',
    secondaryLight: '#ebf8f5'
  },
  green: {
    primary: '#24B352',
    light: '#F0FFEB'
  },
  grey: {
    primary: '#666',
    primaryLight: '#999',
    altDark: '#aaa',
    altLight: '#c9c9c9',
    secondaryDark: '#d4d4d4',
    secondary: '#eee',
    secondaryLight: '#f8f8f8'
  },
  orange: {
    darkest: '#FF8C23',
    primary: '#FFA859',
    lightest: '#FCE5D0'
  },
  red: {
    primary: '#E51D1D',
    secondary: '#e45c5c',
    lightest: '#FFF3F3'
  },
  yellow: {
    darkest: '#E0CF2F',
    primary: '#F8E71C',
    secondary: '#fff6ad',
    lightest: '#FFFEEB'
  }
};
exports.colors = colors;
var leading = {
  full: '22px',
  half: '11px',
  third: '8px',
  fourth: '5px',
  eighth: '3px'
};
exports.leading = leading;
var fonts = {
  sans: {
    family: '"Gotham A", "Gotham B", "Helvetica Neue", Helvetica, Arial, sans-serif',
    weight: {
      light: 300,
      normal: 400,
      bold: 500
    },
    size: {
      xsmall: '10px',
      small: '12px',
      normal: '14px',
      large: '16px',
      xlarge: '18px',
      xxlarge: '28px'
    }
  },
  icons: process.env.NODE_ENV === "production" ? {
    name: "js0508-icons",
    styles: "font-family:'CustomIcons';font-style:normal;font-weight:normal;font-variant:none;text-transform:none;speak:none;;label:icons;"
  } : {
    name: "js0508-icons",
    styles: "font-family:'CustomIcons';font-style:normal;font-weight:normal;font-variant:none;text-transform:none;speak:none;;label:icons;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  }
};
exports.fonts = fonts;
var zindex = {
  page: {
    super: 9999
  },
  modal: {
    above: 9001,
    body: 9000,
    below: 8999
  },
  component: {
    aboveBase: 101,
    base: 100,
    belowBase: 99
  }
};
exports.zindex = zindex;
var settings = {
  page: {
    maxWidth: '1920px'
  },
  mobile: {
    maxWidth: '480px'
  }
};
exports.settings = settings;
var animate = {
  spin: '1.5s',
  fade: '0.3s',
  pulse: '1.5s',
  transition: '0.3s'
};
exports.animate = animate;
var edgeSizes = {
  none: '0px',
  hair: '1px',
  xsmall: '6px',
  small: '12px',
  mediumSmall: '20px',
  medium: '24px',
  large: '48px',
  xlarge: '96px'
};
exports.edgeSizes = edgeSizes;

function themeLookup(obj, stringMatcher) {
  var path = stringMatcher.split('.');
  var branch = obj;
  path.forEach(function (str) {
    if (_typeof(obj) !== 'object' || typeof branch[str] === 'undefined') {
      throw new Error("themeLookup failed: no value ".concat(stringMatcher, " found in object"));
    }

    branch = branch[str];
  });
  return branch;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@contently/toolkit/dist/styles/theme.js
// module id = 10
// module chunks = 0 15 16 17 18